<template>
  <div>
    <app-heading
      :text="'2SG Wholesale Connect Orders'"
      :heading="'main'"
    ></app-heading>

    <v-row class="mb-4">
      <v-col
        cols="12"
        md="8"
        lg="9"
        class="pt-0 pb-0"
        :class="$vuetify.breakpoint.xs ? 'pr-3' : 'pr-0'"
      >
        <!-- TO DO: remove feature flag condition -->
        <v-btn
          v-if="featureFlags && featureFlags.connect5GSq"
          class="primary"
          @click="create5GOrder({})"
          :style="$vuetify.breakpoint.xs ? 'width: 100%' : ''"
          :class="$vuetify.breakpoint.xs ? 'ml-0 mt-4' : 'ml-3 mt-6'"
          >Create 5G Order</v-btn
        >
      </v-col>

      <v-col cols="12" md="4" lg="3">
        <vonex-search
          v-model="keyword"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
          autocomplete="off"
          ref="search"
        ></vonex-search>
        <!-- <app-search @search="search"></app-search> -->
      </v-col>
    </v-row>
    <!-- TO DO: remove feature flag -->
    <app-table
      :items="nbnData"
      :headers="
        featureFlags.connect5GSq
          ? headers
          : headers.filter(
              (x) => x.value !== 'orderType' && x.value !== 'transactionId'
            )
      "
      :cols="3"
      :showButton="true"
      :keyword="keyword"
      :options="options"
      :component="'main'"
      :dataOptions="nbnDataOptions"
      @createNewOrder="showCreateNew = true"
      @signOnGlassOrder="showSogOrder = true"
      @address="checkAddress"
      @qualification="showSQDialog"
      @showAppointment="showAppointment"
      @retrigger="onCreateRadiusAccount"
      @updateOnIseek="updateOnIseek"
      @showOrderDetails="showOrderDetails"
      @updateOrder="updateOrder"
      @cancelOrder="cancelOrder"
      @show5GDetails="show5GDetails"
      @showOriginal="showOriginal"
      @paginationChange="paginationChange"
    ></app-table>

    <signonglass-orders
      :showSogOrder="showSogOrder"
      :items="sogData"
      @close="closeSOGOrderDialog()"
      @createOrder="createOrderFromSOG"
    ></signonglass-orders>
    <!-- TO DO: remove feature flag -->
    <create-order-5g
      v-if="featureFlags && featureFlags.connect5GSq"
      ref="createOrder"
      :showNewOrder="showNewOrder"
      @close="showNewOrder = false"
      @orderSubmitted="closeNewOrder()"
    ></create-order-5g>
    <create-order
      v-else
      ref="createOrder"
      :showNewOrder="showNewOrder"
      @close="showNewOrder = false"
      @orderSubmitted="closeNewOrder()"
    ></create-order>

    <address-dialog
      ref="addressDialog"
      @select="setExistingAddress"
    ></address-dialog>

    <qualification-dialog
      ref="qualificationDialog"
      :showQualification="showQualification"
      :queryAddress="queryAddress"
      @qualification="qualification"
      @cancel="closeQualificationDialog"
      @create="createOrder"
    ></qualification-dialog>

    <view-appointment
      :viewAppointment="viewAppointment"
      :appointmentData="appointmentData"
      @close-appointment="onClose"
    ></view-appointment>

    <order-info
      :showInfoDialog="showInfoDialog"
      :optusOrderID="optusOrderID"
      @close="showInfoDialog = false"
    ></order-info>

    <details-5g
      :show5GDialog="show5GDialog"
      :details5GOrder="details5GOrder"
      @close="show5GDialog = false"
    ></details-5g>
  </div>
</template>

<script>
import { Order } from "@/models/Order";
import { debounce } from "debounce";
export default {
  name: "OrderManagement",
  data: () => ({
    paging: {
      pageNo: 1,
      pageSize: 25,
      keyword: "",
    },
    showQualification: false,
    viewAppointment: false,
    appointmentData: {},
    addressDialogData: [],
    showNewOrder: false,
    showSogOrder: false,
    queryAddress: [],
    keyword: "",
    nbnData: [],
    nbnDataOptions: {},
    sogData: [],
    showInfoDialog: false,
    show5GDialog: false,
    optusOrderID: "",
    details5GOrder: {
      statusReply: "",
      sim: "",
      msn: "",
      accountNumber: 0,
      customerName: "",
      address: "",
    },
    options: {
      sortDesc: true,
      page: 1,
      itemsPerPage: 25,
      sortBy: ["internetID"],
      rowsPerPageItems: [25, 50, 75, 100, -1],
    },
    headers: [
      {
        text: "Actions",
        sortable: false,
        value: "actionsOrder",
      },
      {
        text: "Type",
        sortable: true,
        value: "orderType",
      },
      {
        text: "Order ID",
        sortable: true,
        value: "nbnOrderId",
      },
      {
        text: "System ID",
        sortable: true,
        value: "systemId",
      },
      {
        text: "Customer Name",
        sortable: true,
        value: "customerFirstname",
      },
      {
        text: "Wholesaler Name",
        sortable: false,
        value: "wholesaler",
      },
      {
        text: "Auth Date",
        sortable: true,
        value: "customerAuthDate",
      },
      {
        text: "Status",
        sortable: false,
        value: "status",
      },
      {
        text: "Ticket #",
        sortable: false,
        value: "customerReference",
      },
    ],
  }),
  watch: {
    // keyword() {
    //   let vm = this;
    //   debounce(vm.getData(), 20000);
    // },
    keyword: debounce(function () {
      let vm = this;
      vm.paging.pageNo = 1;
      vm.paging.pageSize = 25;
      vm.getData();
    }, 700),
  },
  computed: {
    underMantainance() {
      let vm = this;
      return vm.featureFlags.sog3690;
    }
  },
  mounted() {
    let vm = this;
    vm.getData();
    vm.$refs.createOrder.setWholesaler();
  },
  methods: {
    paginationChange(val) {
      this.paging.pageNo = val;
      this.getData();
    },
    setFirstName(contactName) {
      let name;
      if (contactName !== "") {
        let nameSplit = contactName.split(" ");
        if (nameSplit.length > 2) {
          let counter = 0;
          while (counter < nameSplit.length - 1) {
            name = `${name} ${nameSplit[counter]}`;
            counter++;
          }
        } else {
          name = nameSplit[0];
        }
        return name;
      }
    },
    setLastName(contactName) {
      if (contactName !== "") {
        let nameSplit = contactName.split(" ");
        return nameSplit[nameSplit.length - 1];
      }
    },
    getData() {
      let vm = this;
      vm.paging.keyword = vm.keyword;
      vm.getNBNOrders(vm.paging).then((data) => {
        vm.nbnDataOptions = data;
        vm.nbnData = data.items;
      });
    },
    search(keyword) {
      let vm = this;
      vm.paging.keyword = keyword;
      vm.keyword = keyword;
      vm.getData();
    },
    updateOrder(item) {
      let vm = this;
      vm.showOrder(item, "update");
    },
    cancelOrder(item) {
      let vm = this;
      vm.showOrder(item, "cancel");
    },
    showOrder(order, action) {
      let vm = this;
      let item = Object.assign({}, order);
      item.withData = true;

      if (action === "update") item.requestType = "Change";
      else item.requestType = "Terminate";

      vm.setLocationID(item.locationId);
      vm.setEnhancedSq({
        serviceabilityClass: "",
        csaid: "",
      });

      item.wholesalerAccount = {
        accountNumber: item.wholesalerAccountNumber,
      };

      //vm.setFormattedSQResult(item);

      vm.getWholesalers().then((data) => {
        item.wholesalerAccount = data.filter(
          (x) => x.accountNumber === item.wholesalerAccountNumber
        );
        vm.createOrder(item);
      });
    },
    createOrder(details) {
      let vm = this;

      if (details.withData) {
        vm.$refs.createOrder.wholesalerAccount = details.wholesalerAccount[0];
        vm.$refs.createOrder.newOrder = new Order({
          locationId: details.locationId,
          orderType: details.requestType,
          contractTermLength: details.contractTermLength,
          avcdBandwidthProfile: details.avcdBandwidthProfile,
          rspDeliveryCircuit: details.rspDeliveryCircuit,
          customerFirstName: details.customerFirstname,
          customerLastName: details.customerSurname,
          customerContactNumber: details.customerContactNo,
          customerContactEmail: details.customerContactEmail,
          customerAuthReference: details.customerReference,
          unidslPotsInterconnect: details.unidslPotsInterconnect,
          serviceClass: details.serviceClass,
          customerReference: details.customerReference,
          centralSplitter: details.centralSplitter,
          specialInstruction: details.specialInstruction,
          portingNumber: details.portingNumber,
          cpiId: details.copperPairId,
          ntdId: details.portId,
          installationWorkforce: details.installationWorkforce,
          contactFirstName: details.firstname,
          contactLastName: details.lastname,
          contactNumber: details.operatorContactNumber,
          contactEmail: details.operatorContactEmail,
          deliveryInstructions: details.deliveryInstructions,
          csaId: details.csaId,
          unidPortId: details.unidPort,
          serviceId: details.serviceId,
          wholesalerAccountNumber: details.wholesaler.wholesalerAccountNumber,
        });
      } else {
        let vm = this;
        details.withData = false;

        if (!vm.isAdmin) {
          vm.$refs.createOrder.newOrder.contactFirstName = "";
          vm.$refs.createOrder.newOrder.contactLastName = "";
          vm.$refs.createOrder.newOrder.contactNumber = "";
        }

        if (vm.wholesalers.length === 1) {
          vm.$refs.createOrder.wholesalerChanged();
          vm.$refs.createOrder.setWholesaler();
        }

        if (vm.orderType === "5g") {
          vm.setOrder5GType();
          let accountId = "5G";
          vm.getMsnList(accountId);
          vm.getSimList(accountId);
          vm.getUBCustomers({ id: -1, keyword: "all" });
        }
      }

      vm.showNewOrder = true;
    },
    createOrderFromSOG(order) {
      let vm = this;
      vm.$refs.createOrder.newOrder = order;
      vm.showNewOrder = true;
    },
    createNbnOrder(data) {
      let vm = this;
      vm.setOriginal(false);
      vm.setLocationID("");
      vm.resetFormattedSQResult();
      vm.setSqResult({});
      vm.setOrderType("nbn");
      vm.createOrder(data);
      if (vm.wholesalers.length === 1) vm.$refs.createOrder.checkLayer();
    },
    create5GOrder(data) {
      let vm = this;
      vm.setOriginal(false);
      vm.resetFullAddress();
      vm.setOrderType("5g");
      vm.createOrder(data);
    },
    checkAddress(data) {
      let vm = this;

      let payload = {
        serviceType: "NBN",
        LocationId: data.item.locationId,
      };

      vm.serviceQualification(payload).then((result) => {
        vm.$nextTick(() => {
          vm.$refs.addressDialog.locId = data.item.locationId;
          vm.$refs.addressDialog.queryAddress(
            result.data.address.additionalParameters
          );
        });
      });
    },
    reformatResult(result) {
      let vm = this;
      let newAddress = [];
      result.forEach((x) => {
        let addressFormat = {
          addressSiteName: vm.setValue(x, "addressSiteName"),
          streetNrFirst: vm.setValue(x, "streetNrFirst"),
          streetNrLast: vm.setValue(x, "streetNrLast"),
          streetName: vm.setValue(x, "streetName"),
          streetType: vm.setValue(x, "streetType"),
          suburb: vm.setValue(x, "suburb"),
          postcode: vm.setValue(x, "postcode"),
          stateOrProvince: vm.setValue(x, "stateOrProvince"),
          longitude: vm.setValue(x, "longitude"),
          latitude: vm.setValue(x, "latitude"),
          locationId: vm.setValue(x, "locationId"),
          formattedAddress: vm.setValue(x, "formattedAddress"),
          lotNumber: vm.setValue(x, "lotNumber")
            ? vm.setValue(x, "lotNumber")
            : "",
        };

        newAddress.push(addressFormat);
      });

      return newAddress;
    },
    setValue(address, name) {
      let value = "";
      address.forEach((x) => {
        if (x.name === name) value = x.value;
      });

      return value;
    },
    showSQDialog(item) {
      let vm = this;

      vm.qualification(item.locationId);
    },
    setExistingAddress(item) {
      let vm = this;
      vm.queryAddress = [item[0].locationId];
      vm.setLocationID(item[0].locationId);

      let payload = {
        serviceType: "NBN",
        LocationId: item[0].locationId,
      };

      vm.serviceQualification(payload).then((data) => {
        vm.setFormattedSQResult(data.data);
        vm.showQualification = true;

        this.$nextTick(() => {
          vm.$refs.qualificationDialog.setResult();
        });
      });
    },
    qualification(item) {
      let vm = this;
      let payload = {
        serviceType: "NBN",
        LocationId: item,
      };

      vm.serviceQualification(payload).then((data) => {
        vm.setLocationID(item);
        vm.setFormattedSQResult(data.data);
        vm.$nextTick(() => {
          vm.$refs.qualificationDialog.setResult();
        });
        vm.showQualification = true;
      });
    },
    closeSOGOrderDialog() {
      let vm = this;
      vm.showSogOrder = false;
    },
    closeQualificationDialog() {
      let vm = this;
      vm.setLocationID("");
      vm.showQualification = false;
    },
    showAppointment(item) {
      let vm = this;
      vm.getAppointmentDetails(item.nbnOrderId).then((data) => {
        vm.appointmentData = data;
        vm.viewAppointment = true;
      });
    },
    onClose() {
      let vm = this;
      vm.viewAppointment = false;
    },
    showOrderDetails(id) {
      let vm = this;
      vm.optusOrderID = id;
      let payload = {
        ORDER_ID: id,
      };
      vm.getOrderDetails(payload).then((result) => {
        if (result) vm.showInfoDialog = true;
      });
    },
    closeNewOrder() {
      let vm = this;
      vm.showNewOrder = false;
      vm.getData();
    },
    show5GDetails(detail) {
      let vm = this;
      vm.get5GOrderDetails(detail.msn).then((result) => {
        let resultData = result.data.body.enquireServicesReply;
        if (result.success) {
          vm.details5GOrder.statusReply =
            resultData.statusReply.statusFlag === "Y"
              ? "YES"
              : result.statusReply.statusFlag;
          vm.details5GOrder.sim = resultData.serviceProfile.primary.sim.text;
          vm.details5GOrder.msn = resultData.serviceProfile.speech.msn;
          vm.details5GOrder.accountNumber =
            resultData.serviceProfile.speech.accountNumber;
          vm.details5GOrder.customerName = `${detail.customerFirstname} ${detail.customerSurname}`;
          vm.details5GOrder.address = detail.address;
          vm.show5GDialog = true;
        }
      });
    },
    setOrder5GType() {
      let vm = this;
      if (vm.orderType === "5g")
        vm.$refs.createOrder.newOrder.orderType = "Add";
    },
    showOriginal(item) {
      let vm = this;
      vm.setSelectedOrder(item);
      vm.setOrderType(item.orderType.toLowerCase());
      vm.setLocationID(item.locationId);
      var reference = item.customerReference
        ? item.customerReference
        : item.customerAuthReference;
        
      vm.getSqResponse(reference).then((result) => {
        if (result === "") {
          //
        } else {
          if (item.orderType === "NBN") {
            vm.setSqResult(result);
          }
        }

        vm.setFormattedSQResult(result);
        vm.setOriginal(true);
        vm.showNewOrder = true;
        vm.setAddressResult([
          {
            formattedAddress: item.address,
          },
        ]);

        if (item.orderType === "5G") {
            vm.$nextTick(() => {
              vm.$refs.createOrder.newOrder = new Order({
                locationId: "",
                orderType: vm.setRequestType(item),
                contractLength: item.contractLength,
                customerReference: item.reference,
                customerAuthReference: item.customerAuthReference,
                customerFirstName: item.customerFirstname,
                customerLastName: item.customerSurname,
                customerContactNumber: item.customerContactNo,
                customerContactEmail: item.customerContactEmail,
                ratePlanID: item.ratePlanID,
                deliverToCustomer: item.deliverToCustomer,
                deliveryAddress: item.deliveryAddress,
                deliveryContactName: item.deliveryContactName,
                deliveryContactCompany: item.deliveryContactCompany,
              });
              vm.get5gRatePlans(item.isRetail);
              vm.set5gRatePlans([
                {
                  ratePlanID: item.ratePlanID,
                  ratePlanDescription: vm.ratePlans5G.filter(
                    (x) => x.ratePlanID === item.ratePlanID
                  ).ratePlanDescription,
                },
              ]);
              vm.getUBCustomers({
                id: item.wholesalerAccountNumber,
                keyword: item.ubCustomerNumber,
              });
              vm.setUbCustomers([
                {
                  customerName: vm.ubCustomers.filter(
                    (x) => x.ubAccountNo === item.ubCustomerNumber
                  ).customerName,
                  ubAccountNo: item.ubCustomerNumber,
                },
              ]);
              vm.setSimList([item.usim]);
              vm.setMsnList([item.msn]);

              vm.$refs.createOrder.wholesalerAccount =
                item.wholesalerAccountNumber;
              vm.$refs.createOrder.displayOrder(item, result);
            });
          } else {
            let csaId = "";
            if (result.parameters) {
              csaId = result.parameters.parameter.find(
                (x) => x.name === "CSAID"
              ).value;
            }

            let specialInstruction = "";
            let cpiId = "";
            let ntdId = "";
            let installationWorkforce = "";
            let contactName = "";
            let contactNumber = "";
            let contactEmail = "";
            let deliveryInstructions = "";
            let unidPortId = "";
            let unidslPotsInterconnect = "";
            let portingNumber = "";

            var reference = item.customerReference
              ? item.customerReference
              : item.customerAuthReference;

            vm.getRequestData(reference).then((request) => {
              if (request.CreateCustomizedOffer) {
                request.CreateCustomizedOffer.baseOffer.serviceFeatures.feature.forEach(
                  (x) => {
                    switch (x.featureKey) {
                      case "NBN_SERVICE_SPEC:SPECIAL_INSTRUCTION":
                        specialInstruction = x.value.value;
                        break;
                      case "NBN_SERVICE_SPEC:DELIVERY_INSTRUCTIONS":
                        deliveryInstructions = x.value.value;
                        break;
                      case "NBN_SERVICE_SPEC:UNIDSL_POTS_INTERCONNECT":
                        unidslPotsInterconnect = x.value.value;
                        break;
                      case "NBN_SERVICE_SPEC:CPI_ID":
                        cpiId = x.value.value;
                        break;
                      case "NBN_SERVICE_SPEC:CONTACT_NAME":
                        contactName = x.value.value;
                        break;
                      case "NBN_SERVICE_SPEC:CONTACT_NUMBER":
                        contactNumber = x.value.value;
                        break;
                      case "NBN_SERVICE_SPEC:CONTACT_EMAIL":
                        contactEmail = x.value.value;
                        break;
                      case "NBN_SERVICE_SPEC:INSTALLATION_WORKFORCE":
                        installationWorkforce = x.value.value;
                        break;
                      case "NBN_SERVICE_SPEC:NTD_ID":
                        ntdId = x.value.value;
                        break;
                      case "NBN_SERVICE_SPEC:UNID_PORT_ID":
                        unidPortId = x.value.value;
                        break;
                      case "NBN_SERVICE_SPEC:PORTING_NUMBER":
                        portingNumber = x.value.value;
                        break;
                    }
                  }
                );
              }

              vm.$nextTick(() => {
                vm.$refs.createOrder.newOrder = new Order({
                  locationId: item.locationId,
                  orderType: vm.setRequestType(item),
                  contractTermLength: item.contractLength,
                  avcdBandwidthProfile: item.avcdBandwidthProfile,
                  customerFirstName: item.customerFirstname,
                  customerLastName: item.customerSurname,
                  customerContactNumber: item.customerContactNo,
                  customerContactEmail: item.customerContactEmail,
                  customerAuthDate: item.customerAuthDate,
                  customerAuthReference: item.customerAuthReference,
                  serviceClass: item.serviceClass,
                  customerReference: item.customerReference,
                  specialInstruction: specialInstruction,
                  cpiId: cpiId,
                  unidslPotsInterconnect: unidslPotsInterconnect,
                  ntdId: ntdId,
                  installationWorkforce: installationWorkforce,
                  contactFirstName: vm.setFirstName(contactName),
                  contactLastName: vm.setLastName(contactName),
                  contactNumber: contactNumber,
                  contactEmail: contactEmail,
                  deliveryInstructions: deliveryInstructions,
                  csaId: csaId,
                  unidPortId: unidPortId,
                  portingNumber: portingNumber,
                  serviceId: item.serviceId,
                  wholesalerAccountNumber: item.wholesalerAccountNumber,
                  ratePlanID: item.ratePlanID,
                  deliveryAddress: item.deliveryAddress,
                  deliveryContactName: item.deliveryContactName,
                  deliveryContactCompany: item.deliveryContactCompany,
                  ubCustomerNumber: item.ubCustomerNumber,
                  isRetail: item.isRetail,
                  deliverToCustomer: item.deliverToCustomer,
                  radiusUsername: item.radiusUsername,
                  radiusPassword: item.radiusPassword,
                  staticIP:
                    request.CreateCustomizedOffer.StaticIP === "true"
                      ? true
                      : false,
                });

                vm.$refs.createOrder.wholesalerAccount =
                  item.wholesalerAccountNumber;
                vm.$refs.createOrder.displayOrder(item, result);

                vm.$refs.createOrder.showLocIdInput = true;
              });
            });
          }
      });
    },
    onCreateRadiusAccount(item) {
      let vm = this;
      vm.createRadiusAccount(item)
        .then((data) => {
          if (data.success)
            vm.setHttpResponse({
              text: `Radius account created successfully.`,
              color: "success",
            });
        })
        .catch(() => {});
    },
    updateOnIseek(item) {
      let vm = this;
      vm.updateOnIseekValue(item)
        .then((data) => {
          if (data.success)
            vm.setHttpResponse({
              text: `Value updated successfully`,
              color: "success",
            });
        })
        .catch(() => {});
    },
    setRequestType(item) {
      if (item.requestType !== null) {
        if (
          item.requestType.toLowerCase() === "add" ||
          item.requestType.toLowerCase() === "new service"
        )
          return "Add";
        else return "Transfer";
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
